<template>
    <div class="monitor-manage">
        <keep-alive :include="cachedViews">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>
<script>
export default {
    name: 'monitorManage',
    data() {
        return {
        };
    },
    computed: {
        cachedViews() {
            return this.$store.state.cachedViews;
        }
    }
};
</script>
<style lang="less">
.monitor-manage {
    flex: 1;
    display: flex;
}
</style>